import { ProductIDs } from './base';

// TODO: currently has no string match may be removed?
export const OlyIDs = {
  PowerDrive: undefined, // 1133,
  PowerDriveDay: undefined, // 1134,
  EVDaySaver: undefined,
  EVNightSaver: undefined,
} as const;

export type OlyIDValues = (typeof OlyIDs)[keyof typeof OlyIDs];

// Excludes products that do not have a Oly promo
export type OlyValidIDs = Extract<
  ProductIDs,
  | typeof ProductIDs.EVDaySaver
  | typeof ProductIDs.EVNightSaver
  | typeof ProductIDs.PowerDrive
  | typeof ProductIDs.PowerDriveDay
>;

export const OlyPlanIDMapping: Record<OlyValidIDs, OlyIDValues> = {
  [ProductIDs.PowerDrive]: OlyIDs.PowerDrive,
  [ProductIDs.PowerDriveDay]: OlyIDs.PowerDriveDay,
  [ProductIDs.EVDaySaver]: OlyIDs.EVDaySaver,
  [ProductIDs.EVNightSaver]: OlyIDs.EVNightSaver,
};
